import React from 'react';
import { ScrollView } from 'react-native';
import { FileType } from 'src/components/10-atoms/file-picker/types';
import AttachmentThumbnail from 'src/components/10-atoms/form/inputs/FileInput/thumbnail/AttachmentThumbnail';
import { getFileType } from 'src/components/10-atoms/form/inputs/FileInput/utils';
import Row from 'src/components/10-atoms/layout/Row';
import { imageViewHelperActions } from 'src/components/20-helper-views/image-viewer/useImageViewer';
import { pdfViewHelperActions } from 'src/components/20-helper-views/pdf-viewer/usePDFViewer';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const AttachmentThumbnailList = ({ data, disablePreview = false, ...rowProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const handleImagePress = (index = 0) => {
        const type = getFileType(data[index].uri);
        if (type === FileType.PDF) {
            pdfViewHelperActions.show({
                src: data[index].uri,
            });
        }
        else {
            imageViewHelperActions.show({
                initialIndex: index,
                images: data.map(item => ({
                    uri: item.uri,
                })),
            });
        }
    };
    return (React.createElement(Row, { ph: theme.spacing.page, pv: theme.spacing.standard.xs, ...rowProps },
        React.createElement(ScrollView, { horizontal: true },
            React.createElement(Row, { spacing: theme.spacing.standard.xs }, data.map((item, index) => (React.createElement(AttachmentThumbnail, { key: item.uri, src: item.uri, disablePreview: disablePreview, onPress: () => handleImagePress(index) })))))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default AttachmentThumbnailList;
